import type { FC, PropsWithChildren } from 'react';
import ChatInputStyle from '../ChatInput/ChatInput.module.css';
import Button from '../Button';

type TextAreaProps = PropsWithChildren<{
  icon_tooltip?:string
  icon2_tooltip?:string
  icon?: string;
  icon2?:string
  className?: string;
  placeholder: string;
  rows?: number;
  value: string;
  errorMessage?: string;
  disabled?: boolean;
  defaultValue?: string;
  style?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onClickIcon?: React.MouseEventHandler<SVGSVGElement>;
  onClickIcon2?: React.MouseEventHandler<SVGSVGElement>;
}>;

const ChatInputBox: FC<TextAreaProps> = ({ icon_tooltip,icon2_tooltip,icon, icon2, className, placeholder, rows = 4, value, onChange, errorMessage, style, disabled, defaultValue, onClickIcon,  onClickIcon2 }) => {
  return (
    <div className={ChatInputStyle.form_input}>
      <div className={ChatInputStyle.form_input__container} style={style}>
       
        <textarea
          disabled={disabled ? disabled : false}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          className={`${ChatInputStyle.form_input__box} ${className || ''}`}
          rows={rows}
        />
        <div style={{display:'flex'}}>
        {icon && (
    <svg
    className={ChatInputStyle.form_input__icon}
    onClick={onClickIcon}
    data-tooltip={icon_tooltip}
  
  >
    <use xlinkHref={`/assets/sprite.svg#${icon}`} />
  </svg>
        )}
         { icon2 && (
          <svg  className={ChatInputStyle.form_input__icon} onClick={onClickIcon2}  data-tooltip={icon2_tooltip}>
            <use xlinkHref={`/assets/sprite.svg#${icon2}`} />
          </svg>
        )}
        </div>
      

      </div>
      {errorMessage && <p className={ChatInputStyle.form_input__error}>{errorMessage}</p>}
    </div>
  );
};

export default  ChatInputBox;
